import { useState } from 'react';
import { useApi, configApiRef, identityApiRef } from '@backstage/core-plugin-api';

export const usePlanPreview = () => {
  const configApi = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const [planMarkdown, setPlanMarkdown] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchPlan = async (ticketId: string) => {
    setLoading(true);
    setPlanMarkdown(null);
    try {
      const backendUrl = configApi.getString('backend.baseUrl');
      const { token } = await identityApi.getCredentials();
      const res = await fetch(`${backendUrl}/api/custom-api/requirement-agent/plans/${ticketId}`, {
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
      if (res.status === 404) { setPlanMarkdown(null); return; }
      if (!res.ok) throw new Error(`Failed to fetch plan: ${res.status}`);
      const data = await res.json();
      setPlanMarkdown(data.plan ?? null);
    } catch {
      setPlanMarkdown(null);
    } finally {
      setLoading(false);
    }
  };

  const clearPlan = () => setPlanMarkdown(null);

  return { planMarkdown, setPlanMarkdown, loading, fetchPlan, clearPlan };
};